import React,{useState} from 'react';
import {
  Grid,
  Card,
  Typography,
  Box,
  Avatar,
  Button,
} from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import iconBasket from "../../../../assets/icon-basket-light.png"
import { useTheme } from "styled-components";
import DownloadAppModal from "../Components/DownloadAppModal"

const ArtworksComponent = ({ artworks }) => {
  const theme = useTheme();
 const [open, setOpen] = useState(false);

  return (
    <Grid container spacing={4}>
    <DownloadAppModal open={open} onClose={() => setOpen(false)} />
      {artworks.map((art, index) => (
        <Grid item xs={12} sm={6} md={4} lg={4} key={index}>
          <Card
            sx={{
              borderRadius: '20px',
              backgroundColor: '#2e2b4f',
              color: 'white',
              padding: 3,
              height: 500,
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between',
            }}
          >
            {/* Top: Profile + Title + Description */}
            <Box>
              <Box display="flex" alignItems="flex-start" gap={2} mb={2}>
                {art.art.userProfile ? (
                  <Avatar
                    src={art.art.userProfile}
                    alt={art.art.userName}
                    sx={{ width: 48, height: 48 }}
                  />
                ) : (
                  <Avatar sx={{ bgcolor: '#888', width: 48, height: 48 }}>
                    <PersonIcon />
                  </Avatar>
                )}

                <Box>
                  <Typography
                    variant="h6"
                    sx={{
                      fontFamily: 'basic-sans',
                      fontWeight: 700,
                      lineHeight: 1.2,
                    }}
                    gutterBottom
                  >
                    {art.art.title}
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{
                      fontFamily: 'basic-sans',
                      color: '#ccc',
                      height: 60,
                      overflowY: 'auto',
                      paddingRight: 1,
                    }}
                  >
                    {art.art.description}
                  </Typography>
                </Box>
              </Box>

              {/* Media Display */}
              <Box sx={{ borderRadius: '16px', overflow: 'hidden', mb: 2 }}>
                {art.art.expectedMediaType === 'Video' ? (
                  <video
                    src={art.art.location.cdnUrl + "/_main_fullscreen.mp4"}
                    controls
                    controlsList="nodownload"
                    style={{ width: '100%', height: '200px', objectFit: 'cover' }}
                  />
                ) : (
                  <img
                    src={art.art.location.cdnUrl + "/_main.jpg"}
                    alt="Artwork"
                    style={{
                      width: '100%',
                      height: '200px',
                      display: 'block',
                      objectFit: 'cover',
                    }}
                  />
                )}
              </Box>
            </Box>

            {/* Bottom: Purchase Button with Price */}
            <Button
              fullWidth
              variant="contained"
              onClick={()=>{setOpen(true)}}
              sx={{
                backgroundColor: theme.colors.green,
                textTransform: 'none',
                fontWeight: 600,
                fontFamily: 'basic-sans',
                borderRadius: 2,
                paddingY: 1.5,
                justifyContent: 'space-between',
                '&:hover': { backgroundColor: theme.colors.green },
              }}
            >
              <Box>Purchase Editions</Box>

              <Box display="flex" alignItems="center" gap={1}>
                <Typography
                  variant="subtitle1"
                  sx={{ fontWeight: 600, fontFamily: 'basic-sans' }}
                >
                  ${art?.art?.currentMarketValue?.marketPricePerShare}
                </Typography>
                <img
                  src={iconBasket}
                  alt="Basket"
                  style={{ height: '20px' }}
                />
              </Box>
            </Button>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};

export default ArtworksComponent;
